import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AlertService } from '.';

@Injectable({
    providedIn: 'root'
})

export class DataHoraService
{
    constructor(private http: HttpClient, private alertService: AlertService) { }

    ValidarDataVencimento(dataVencimento: Date, tipoDocumento: number): Observable<any>  {
        const apiURL = `${environment.apiUrl}/api/Data/ValidarDataVencimento/${moment(dataVencimento).format('DDMMYYYYhhmm')}/${tipoDocumento}`;
        return this.http.get<any>(apiURL);
    }
}
